import React from 'react';
import cn from "classnames";

import { IconName } from '@fortawesome/fontawesome-svg-core';

import classes from './Button.module.scss';

interface ButtonProps {
  callback?: VoidFunction | Function | any;
  iconText?: IconName;
  text: string;
  customClass?: string;
  disabled?: boolean;
}

export default function Button(props: ButtonProps) {
  const { callback, text, customClass, disabled } = props;

  function handleFormEvent(event: any) {
    event.preventDefault();
    event.stopPropagation();

    if (callback) callback();
  }

  return (
    <button className={cn(classes.Button, customClass, disabled && classes.disabled)} onClick={handleFormEvent} disabled={disabled} >
      <span className={classes.text}> {text}</span>
    </button>
  );
}
